import { render, staticRenderFns } from "./DietaryHabits.vue?vue&type=template&id=1183fa9e&scoped=true"
import script from "./DietaryHabits.vue?vue&type=script&lang=js"
export * from "./DietaryHabits.vue?vue&type=script&lang=js"
import style0 from "./DietaryHabits.vue?vue&type=style&index=0&id=1183fa9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1183fa9e",
  null
  
)

export default component.exports